// extracted by mini-css-extract-plugin
export default {"form":"styles_form__0JrLD","container":"styles_container__cFZKA","input":"styles_input__kXIHh","image":"styles_image__ZkK3Y","photoContainer":"styles_photoContainer__ZgDVX"};